// @flow

import { CSSTransition, Transition, TransitionGroup } from 'react-transition-group';
import * as React from 'react';

import { Button, Footer } from '@sonyged/ext-proc';

import { AnimatedPizza } from './AnimatedPizza';
import type { FinishedRound } from './domain/Round';
import { PizzaIngredientIcon } from './icons/PizzaIngredientIcon';
import AppContext from '../../../AppContext';
import AutoScaleContainer from './AutoScaleContainer';
import PizzaHera from './PizzaHera';
import PizzaKitchen from './PizzaKitchen';

type Props = {
  round: FinishedRound,
  onNext: FinishedRound => void,
};

type State = {
  current: 'crust' | 'sauce' | 'cheese' | number,
  done: boolean,
};

class PizzaCookingView extends React.Component<Props, State> {
  static contextType = AppContext;

  constructor(props: Props) {
    super(props);

    this.state = {
      current: 'crust',
      done: false,
    };

    (this: any).next = this.next.bind(this);
  }

  componentDidMount() {
    setTimeout(this.next, 1000);
  }

  next() {
    const current = this.state.current;
    if (current === 'crust') {
      this.context.soundController.sePlay('topping');
      return this.setState({ current: 'sauce' });
    }
    if (current === 'sauce') {
      this.context.soundController.sePlay('topping');
      return this.setState({ current: 'cheese' });
    }

    const currentToppingIndex = typeof current === 'string' ? -1 : current;
    const toppingCount = this.props.round.pizza.toppings.length;
    if (toppingCount && currentToppingIndex < toppingCount - 1) {
      this.context.soundController.sePlay('topping');
      return this.setState({ current: currentToppingIndex + 1 });
    } else {
      if (!this.state.done) return this.setState({ done: true });

      this.props.onNext(this.props.round);
    }
  }

  render() {
    return (
      <div className="pizza-inner-view pizza-cooking-view">
        <div className={'proc-contents padding relative'}>
          <AutoScaleContainer
            className="tertiary100-bg-color"
            preferedWidth={864}
            preferedHeight={474}
            preferedMinHeight={474}
            preferedMinWidth={350}
          >
            <PizzaKitchen>
              <TransitionGroup>
                {this.state.done && (
                  <Transition timeout={0}>
                    <PizzaHera />
                  </Transition>
                )}
                {!this.state.done && (
                  <CSSTransition timeout={1500} onExited={this.next} classNames="proc-pizza" key="pizza">
                    <AnimatedPizza
                      current={this.state.current}
                      pizza={this.props.round.pizza}
                      onAnimationEnd={this.next}
                    />
                  </CSSTransition>
                )}
              </TransitionGroup>
            </PizzaKitchen>
          </AutoScaleContainer>
          <div className="ingredient-icons">
            <PizzaIngredientIcon selected={this.state.current === 'crust'} ingredient={this.props.round.pizza.crust} />
            <PizzaIngredientIcon
              selected={this.state.current === 'sauce' || this.state.current === 'cheese'}
              ingredient={this.props.round.pizza.sauce}
            />
            {this.props.round.pizza.toppings.map((topping, i) => {
              return (
                topping && <PizzaIngredientIcon selected={this.state.current === i} key={i} ingredient={topping} />
              );
            })}
          </div>
        </div>
        <Footer.normal>
          <Button.attention disabled>つぎへ</Button.attention>
        </Footer.normal>
      </div>
    );
  }
}

export default PizzaCookingView;
